import axios from 'axios';
import API_BASE_URL from '../config.js';

const getCompany = async (event) => {

    const response = await axios.get(`${API_BASE_URL}/company/`,
    );

    return response.data;

};

export default getCompany;
